import { Smartphone, Globe, Download } from "lucide-react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=app.tuiglesia";
const WEB_APP_URL = "https://app.tuiglesia.app";

export default function DownloadCTA() {
  return (
    <section
      data-testid="download-cta-section"
      className="animate-stagger-5 px-5 py-10"
    >
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 mb-3 bg-[#056A84]/10 px-4 py-1.5 rounded-full border border-[#056A84]/15">
          <Download className="w-4 h-4 text-[#056A84]" />
          <span className="text-xs uppercase tracking-[0.15em] text-[#056A84] font-heading font-semibold">
            Ya disponible
          </span>
        </div>
        <h2
          data-testid="download-title"
          className="font-heading text-2xl font-bold text-[#111827] mb-2"
        >
          Tu Iglesia en tu bolsillo
        </h2>
        <p className="text-sm text-[#4B5563] max-w-xs mx-auto">
          Descárgala en Google Play o accede directo desde la web.
        </p>
      </div>

      <div className="flex flex-col gap-3 max-w-sm mx-auto">
        {/* Google Play - Active */}
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="download-google-play"
          className="cta-glow flex items-center justify-center gap-3 bg-[#00CCFF] text-white font-heading font-bold text-sm py-4 px-6 rounded-full hover:bg-[#00b8e6] active:scale-95 transition-all duration-200"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302-2.302 2.302-2.722-2.302 2.722-2.302zM5.864 2.658L16.8 8.99l-2.302 2.302-8.635-8.635z" />
          </svg>
          Descargar en Google Play
        </a>

        {/* Web app - Active */}
        <a
          href={WEB_APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="download-web"
          className="flex items-center justify-center gap-3 bg-[#056A84] text-white font-heading font-bold text-sm py-4 px-6 rounded-full hover:bg-[#045670] active:scale-95 transition-all duration-200"
        >
          <Globe className="w-5 h-5" />
          Abrir versión web
        </a>

        {/* App Store - Disabled */}
        <button
          data-testid="download-app-store"
          disabled
          className="flex flex-col items-center justify-center gap-0.5 bg-transparent text-gray-400 font-heading font-bold text-sm py-3 px-6 rounded-full border-2 border-gray-200 cursor-not-allowed opacity-70"
        >
          <div className="flex items-center gap-3">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            App Store
          </div>
          <span className="text-[10px] uppercase tracking-widest text-gray-400 font-normal">
            Próximamente
          </span>
        </button>
      </div>

      <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-400">
        <Smartphone className="w-3.5 h-3.5" />
        <span>Compatible con Android · Web funciona en cualquier navegador</span>
      </div>
    </section>
  );
}
